import Pagination from "components/Pagination/TablePagination";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  clearSponsorsRepresentativesRequest,
  getSponsorsRepresentativesRequests,
} from "../../actions/users";
import { Link } from "react-router";

const labels = ["Date", "MedMeeting Group", "Meeting Title", "Value", "Status"];

const statusToLabel = {
  approved: "Approved",
  rejected: "Rejected",
};

class RepresentiveNotPendingRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 5,
      status: "not_pending",
    };
  }

  componentWillUnmount() {
    this.props.clearSponsorsRepresentativesRequest();
  }

  componentDidMount() {
    this.props.getSponsorsRepresentativesRequests(this.state);
  }

  onChangePage = (page) =>
    this.setState({ page }, () =>
      this.props.getSponsorsRepresentativesRequests(this.state)
    );

  render() {
    const { requests } = this.props;
    const { page } = this.state;

    const data = requests ? requests.data : [];
    const totalPages = requests ? requests.totalPages : 0;
    const count = requests ? requests.count : 0;

    return (
      <main
        style={{
          width: "80%",
          margin: "auto",
          minHeight: "auto",
        }}
      >
        <div
          className="group-requests"
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <h4 style={{ flex: "1 1 auto" }}>Previous Requests ({count})</h4>
          <Link to={"/requests/pending"}>
            <button className="button_link">Back to Pending Requests</button>
          </Link>
        </div>
        <div style={{ width: "100%", overflowX: "auto", marginTop: "12px" }}>
          <table>
            <thead>
              <tr>
                {labels.map((label, idx) => (
                  <th key={idx}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <RequestItem key={idx} {...item} />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={totalPages}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  requests: state.users.sponsorRepresantiveRequests,
});

const mapDispatchToProps = (dispatch) => ({
  getSponsorsRepresentativesRequests: (params) =>
    dispatch(getSponsorsRepresentativesRequests(params)),
  clearSponsorsRepresentativesRequest: () =>
    dispatch(clearSponsorsRepresentativesRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RepresentiveNotPendingRequests);

class RequestItem extends Component {
  render() {
    const {
      group_title,
      webinar_title,
      webinar_start_date,
      sponsorship_value,
      status,
    } = this.props;

    return (
      <tr>
        <td>{moment(webinar_start_date).format("DD/MM/yyyy")}</td>
        <td>{group_title}</td>
        <td>{webinar_title}</td>
        <td>{sponsorship_value}</td>
        <td>{statusToLabel[status]}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RepresentiveRequests/RepresentiveNotPendingRequests.jsx